.w{overflow:hidden;}